module.exports = __webpack_public_path__ + "img/immuTest1.88b35918.png";